import React from 'react';
import { useContent } from '../hooks/useContent';
import styles from './NewRole.module.css';

export default function NewRole() {
  const { ui } = useContent();
  const nr = ui.newRole;

  return (
    <section className={styles.section} id="new-role">
      <div className={styles.bgGlow1} />
      <div className={styles.bgGlow2} />

      <div className={styles.container}>
        <div className={styles.header}>
          <span className={styles.badge}>{nr.badge}</span>
          <h2 className={styles.title}>{nr.title}</h2>
          <p className={styles.subtitle}>{nr.subtitle}</p>
        </div>

        <div className={styles.goalVision}>
          <div className={styles.sideCard + ' ' + styles.cardTo}>
            <div className={styles.cardLabel}>{nr.goal}</div>
            <div className={styles.cardDesc}>{nr.goalText}</div>
          </div>
          <div className={styles.sideCard + ' ' + styles.cardTo}>
            <div className={styles.cardLabel}>{nr.vision}</div>
            <div className={styles.cardDesc}>{nr.visionText}</div>
          </div>
        </div>

        <div className={styles.pillarsTitle}>{nr.pillarsTitle}</div>
        <div className={styles.pillars}>
          {nr.pillars.map((p, i) => (
            <div className={styles.pillar} key={i}>
              <h3 className={styles.pillarTitle}>{p.title}</h3>
              <p className={styles.pillarDesc}>{p.desc}</p>
            </div>
          ))}
        </div>

        <div className={styles.pillarsTitle + ' ' + styles.blockGap}>{nr.roadmapTitle}</div>
        <div className={styles.roadmap}>
          {nr.roadmap.map((item, i) => (
            <div className={styles.roadmapCard} key={i}>
              <div className={styles.roadmapStep}>{i + 1}</div>
              <div>
                <h3 className={styles.pillarTitle}>{item.title}</h3>
                <p className={styles.pillarDesc}>{item.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div className={styles.pillarsTitle + ' ' + styles.blockGap}>{nr.ecosystemTitle}</div>
        <div className={styles.transformation}>
          <div className={styles.side}>
            <div className={styles.sideLabel + ' ' + styles.labelFrom}>
              <span className={styles.dot + ' ' + styles.dotFrom} />
              {nr.before}
            </div>
            <div className={styles.chips}>
              {nr.beforeSystems.map((item) => (
                <span className={styles.chip} key={item}>{item}</span>
              ))}
            </div>
          </div>

          <div className={styles.arrowWrap}>
            <div className={styles.arrowIcon}>→</div>
          </div>

          <div className={styles.side}>
            <div className={styles.sideLabel + ' ' + styles.labelTo}>
              <span className={styles.dot + ' ' + styles.dotTo} />
              {nr.after}
            </div>
            <div className={styles.chips}>
              {nr.afterSystems.map((item) => (
                <span className={styles.chip + ' ' + styles.chipTo} key={item}>{item}</span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
